import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'ri-resolution-ui-panel-header',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelHeaderComponent {
  readonly template = contentChild<TemplateRef<unknown>>('header');
}
